import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../../utils";


export const fetchAllUsers = createAsyncThunk(
    "admin/fetchAccounts",
    async () => {
        const response = await apiFetch("api/a/accounts");
        return await response.json();
    }
);

const tenantSlice = createSlice({
    name: "adminTenant",
    initialState: {
        users: [],
        loading: false,
        error: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllUsers.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(fetchAllUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload || [];
            })
            .addCase(fetchAllUsers.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

export default tenantSlice.reducer;